module.exports = __webpack_public_path__ + "static/media/trello.5292bd86.svg";